import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { OneOf } from '@/components/molecules/OneOf';
import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { useTranslator } from '@/hooks/useTranslator';
import { ModalFlowContext } from '@/types/modalFlowContext';
import { OneOfOption } from '@/types/oneOfOption';

export const NewOrExistingContactFlowModal: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const modal = useOutletContext<ModalFlowContext>();
  const tr = useTranslator();

  const [existingOrNewContact, setExistingOrNewContact] = React.useState<
    'new-contact' | 'existing-contact'
  >('existing-contact');

  const typeOptions = React.useMemo(
    (): readonly OneOfOption[] => [
      {
        label: tr('EXISTING_CONTACT'),
        value: 'existing-contact',
      },
      {
        label: tr('NEW_CONTACT'),
        value: 'new-contact',
      },
    ],
    [tr],
  );

  const goBack = React.useCallback((): void => {
    modal.close();
  }, [modal]);

  const onNext = React.useCallback((): void => {
    navigate(existingOrNewContact);
  }, [navigate, existingOrNewContact]);

  const onValueUpdate = React.useCallback(
    (value: string): void => {
      if (value === 'new-contact' || value === 'existing-contact') {
        setExistingOrNewContact(value);
      }
    },
    [setExistingOrNewContact],
  );

  return (
    <ApplicationModal title={tr('ADD_PAYMENT_METHOD_TO_EXISTING_CONTACT_TITLE')} onClose={goBack}>
      <Box display="flex" flexDirection="column" gap={6}>
        <Box display="flex" flexDirection="column" gap={2}>
          <OneOf
            label={tr('SELECT_TYPE')}
            options={typeOptions}
            value={existingOrNewContact}
            onValueChange={onValueUpdate}
          />
        </Box>

        <Button variant="dark" fullWidth={true} onClick={onNext}>
          {tr('NEXT')}
        </Button>
      </Box>
    </ApplicationModal>
  );
};
